/**
 * Size guide modal
 *
 */
(() => {
  if (window.__sizeGuideModalBound) return;
  window.__sizeGuideModalBound = true;

  const body = document.body;

  const reparent = (modal, trigger) => {
    const hostDialog = trigger.closest('dialog[open]');
    const destination = hostDialog || body;

    if (modal.parentElement !== destination) {
      destination.appendChild(modal);
    }
  };

  const openModal = (modal, trigger) => {
    if (!modal) return;

    reparent(modal, trigger);

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    body.classList.add('size-guide-modal-open');
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');

    const hasOpenModal = document.querySelector('[data-size-guide-modal]:not([hidden])');
    if (!hasOpenModal) {
      body.classList.remove('size-guide-modal-open');
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-guide-open]');
    if (openButton) {
      const modalId = openButton.getAttribute('data-size-guide-open');
      const modal = document.getElementById(modalId);
      openModal(modal, openButton);
      return;
    }

    const closeButton = event.target.closest('[data-size-guide-close]');
    if (closeButton) {
      const modal = closeButton.closest('[data-size-guide-modal]');
      closeModal(modal);
      return;
    }

    const overlay = event.target.closest('[data-size-guide-overlay]');
    const shell = event.target.closest('[data-size-guide-shell]');

    if (overlay && !shell) {
      const modal = overlay.closest('[data-size-guide-modal]');
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openModalEl = document.querySelector('[data-size-guide-modal]:not([hidden])');
    if (openModalEl) {
      closeModal(openModalEl);
    }
  });
})();
